import { render, staticRenderFns } from "./FingerPrintLogin.vue?vue&type=template&id=5a60bc3a&scoped=true"
import script from "./FingerPrintLogin.vue?vue&type=script&lang=js"
export * from "./FingerPrintLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60bc3a",
  null
  
)

export default component.exports